/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getPayloadObject, getTelemetryAttributes, ITelemetryContent, onTelemetryClick } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ILinksData } from '../promo-banner.props.autogenerated';

export interface IPromoBannerLinks {
    links: ILinksData[];
    requestContext: Msdyn365.IRequestContext;
    telemetryContent: ITelemetryContent;
    onTextChange?(index: number): (event: Msdyn365.ContentEditableEvent) => void;
}

export const PromoBannerLinks: React.FC<IPromoBannerLinks> = ({ links, requestContext, onTextChange, telemetryContent }) => {
    const editableLinks = _mapEditableLinks(links, telemetryContent);
    return (
        <span className='ms-promo-banner__links'>
            {editableLinks && editableLinks.length > 0 ? <Msdyn365.Links
                links={editableLinks}
                editProps={{ onTextChange, requestContext }}
            /> : null}
        </span>
    );
};

const _mapEditableLinks = (linkdata: ILinksData[], telemetryContent: ITelemetryContent): Msdyn365.ILinksData[] | null => {
    if (!linkdata || linkdata.length === 0) {
        return null;
    }
    const editableLinks: Msdyn365.ILinksData[] = [];
    linkdata.forEach((link, index) => {
        // Construct telemetry attribute to render
        const payLoad = getPayloadObject('click', telemetryContent, '', '');
        const linkText = link.linkText ? link.linkText : '';
        payLoad.contentAction.etext = linkText;
        const attributes = getTelemetryAttributes(telemetryContent, payLoad);
        const editableLink: Msdyn365.ILinksData = {
            ariaLabel: link.ariaLabel,
            className: 'ms-promo-banner__link',
            linkText: link.linkText,
            linkUrl: link.linkUrl.destinationUrl,
            openInNewTab: link.openInNewTab,
            role: 'link',
            additionalProperties: attributes,
            onClick: onTelemetryClick(telemetryContent, payLoad, linkText)
        };
        editableLinks.push(editableLink);
    });

    return editableLinks;
};
